<template>
  <div class="container">
    <img :src="imgs[0]" class="top-img" alt="背景图">
    <div class="box-wrapper">
      <div v-if="$route.params.type === '1'" class="box" @click="toAddressPage">
        <img :src="imgs[1]" class="left-icon" alt="icon">
        <div>
          <div class="title">填写收货信息</div>
          <div class="sub-title">购买课程后，请由此入口填写收货信息</div>
        </div>
        <img :src="imgs[3]" class="right-icon" alt="right">
      </div>
      <div class="box" @click="toCheckPhonePage">
        <img :src="imgs[2]" class="left-icon" alt="icon">
        <div>
          <div class="title">查询物流信息</div>
          <div class="sub-title">由此可查看您下单产品的物流信息</div>
        </div>
        <img :src="imgs[3]" class="right-icon" alt="right">
      </div>
    </div>
    <div class="tooltip">此入口仅供《哔哩哔哩》app 中下单用户查看发货情况使用</div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  data() {
    return {
      courseId: this.$route.query.courseId,
      imgs: [
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/bilibiliShipments/%E7%BC%96%E7%BB%84%202%402x.png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/bilibiliShipments/%E7%BC%96%E7%BB%84%402x.png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/bilibiliShipments/%E7%BC%96%E7%BB%84%203%402x%20(1).png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/bilibiliShipments/%E5%B7%A6%402x.png`,
      ],
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  methods: {
    toAddressPage() {
      // 校验是否登录
      const courseIdQuery = this.courseId ? `?courseId=${this.courseId}` : '';
      if (!this.userInfo?.id) {
        this.$router.push({ path: '/registrationLogin', query: { redirect: `/bilibili-shipments/order-info${courseIdQuery}` } });
      } else {
        this.$router.push({
          path: `/bilibili-shipments/order-info${courseIdQuery}`,
        });
      }
    },
    toCheckPhonePage() {
      this.$router.push({
        path: '/bilibili-shipments/check-phone',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  background: #F7F8FC;

  .top-img {
    width: 750px;
    height: 424px;
  }

  .left-icon {
    width: 58px;
    height: 58px;
  }

  .right-icon {
    width: 13px;
    height: 24px;
    margin-top: 33px;
  }
}
.box-wrapper {
  position: absolute;
  top: 408px;
}
.box {
  display: flex;
  width: 678px;
  height: 178px;
  margin-bottom: 22px;
  margin-left: 36px;
  padding: 44px 32px;
  color: #333;
  background-color: #fff;
  border-radius: 14px;

  .title {
    width: 482px;
    margin-bottom: 14px;
    margin-left: 25px;
    font-weight: 500;
    font-size: 29px;
  }

  .sub-title {
    width: 482px;
    margin: 0 38px 0 25px;
    font-size: 25px;
  }
}

.tooltip {
  position: absolute;
  bottom: 154px;
  left: 42px;
  width: 667px;
  color: #333;
  font-size: 24px;
  line-height: 33px;
  text-align: center;
}
</style>
